import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ScheduleTaskFilter } from '../models/scheduleTask-filter.model';
import { ConfigurationService } from '../shared/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ScheduleUserFilterService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);


  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.workloadsApiUrl}api`;
  }

  schedulefilters(): Observable<Array<ScheduleTaskFilter>> {
    return this.http.get<Array<ScheduleTaskFilter>>(`${this.backUrl}/Tasks/schedulefilters`);
  }
  
  removeschedulefilters(filterId: string): Observable<ScheduleTaskFilter> {
    return this.http.delete<ScheduleTaskFilter>(`${this.backUrl}/Tasks/removeschedulefilters/${filterId}`);
  } 
  
  addschedulefilters(model: ScheduleTaskFilter): Observable<any> {
    return this.http.post(`${this.backUrl}/Tasks/addschedulefilters`, model);
  }
}
